export function buildUIScoreboardData(event) {
    if (event.scoreboard) {
        return {
            scoreboardProps: {
                scoreFirstPlayer: event.scoreboard.additionalScoreData1,
                scoreSecondPlayer: event.scoreboard.additionalScoreData2,
                totalFirstPlayer: scoreOrEmpty(event.score1),
                totalSecondPlayer: scoreOrEmpty(event.score2),
                modifier: "superbanner"
            },
            onService: event.scoreboard.onServe,
        };
    }
    return {
        scoreboardProps: {
            scoreFirstPlayer: [],
            scoreSecondPlayer: [],
            totalFirstPlayer: scoreOrEmpty(event.score1),
            totalSecondPlayer: scoreOrEmpty(event.score2),
            modifier: "superbanner"
        }
    };
}
function scoreOrEmpty(score) {
    return score || "";
}
//# sourceMappingURL=buildUIScoreboardData.js.map